'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002497 from "./presto.types$$anon$97.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$96() {
  this.c2R = null;
  this.c2J = null;
  this.c2K = false;
  this.c2S = null;
  this.c2T = false;
  this.c2W = null;
  this.c2P = null;
  this.c2Q = false;
  this.c2L = null;
  this.c2M = false;
  this.c2N = null;
  this.c2O = false;
  this.c2U = false;
  this.c2V = false;
  this.c2R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c2W = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$96 as $c_Lpresto_types$$anon$96 };
$p = $c_Lpresto_types$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$96;
/** @constructor */
function $h_Lpresto_types$$anon$96() {
}
export { $h_Lpresto_types$$anon$96 as $h_Lpresto_types$$anon$96 };
$h_Lpresto_types$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c2R;
});
$p.M = (function() {
  if ((!this.c2K)) {
    this.c2J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c2K = true;
  }
  return this.c2J;
});
$p.O = (function() {
  if ((!this.c2T)) {
    this.c2S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c2T = true;
  }
  return this.c2S;
});
$p.E = (function() {
  return this.c2W;
});
$p.t = (function() {
  if ((!this.c2Q)) {
    this.c2P = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2Q = true;
  }
  return this.c2P;
});
$p.N = (function() {
  if ((!this.c2M)) {
    this.c2L = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c2M = true;
  }
  return this.c2L;
});
$p.Q = (function() {
  if ((!this.c2O)) {
    this.c2N = new $j_presto$002etypes$0024$0024anon$002497.$c_Lpresto_types$$anon$97();
    this.c2O = true;
  }
  return this.c2N;
});
$p.v = (function() {
  if ((!this.c2V)) {
    this.c2U = false;
    this.c2V = true;
  }
  return this.c2U;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee127) => ((p) => \u03b4scrutinee127.cqV(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$96, "presto.types$$anon$96", ({
  YG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$96 as $d_Lpresto_types$$anon$96 };
//# sourceMappingURL=presto.types$$anon$96.js.map
